export const privacy = {
  "privacy.title": "Politique de confidentialité",
  "privacy.subtitle": "Votre vie privée est importante pour nous. Découvrez comment nous protégeons vos données.",
  "privacy.last_update": "Dernière mise à jour :",
  "privacy.intro_title": "1. Introduction",
  "privacy.data_collection_title": "2. Informations que nous collectons",
  "privacy.data_usage_title": "3. Comment nous utilisons vos informations",
  "privacy.data_sharing_title": "4. Partage de vos informations",
  "privacy.data_security_title": "5. Sécurité des données",
  "privacy.your_rights_title": "6. Vos droits",
  "privacy.cookies_title": "7. Cookies",
  "privacy.data_retention_title": "8. Conservation des données",
  "privacy.international_transfers_title": "9. Transferts internationaux",
  "privacy.policy_changes_title": "10. Modifications de cette politique",
  "privacy.contact_title": "11. Contact",
  "privacy.provided_info_title": "2.1 Informations que vous nous fournissez",
  "privacy.auto_collected_title": "2.2 Informations collectées automatiquement",
  "privacy.cookies_types_title": "Types de cookies utilisés :",
  "privacy.contact_email": "Email :",
  "privacy.contact_address": "Adresse :",
  "privacy.contact_phone": "Téléphone :"
};

export default privacy;
